<template>
  
  <base-material-card
    color="primary"
    icon="mdi-sigma"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Valores
      </div>
    </template>

    <v-container class="py-0">
      <v-row
        align="center"
        justify="start"
        class="mt-2"
      >
        <draggable v-bind="dragOptions" v-model="selected" handle="#dragHandle">
          <v-chip
            v-for="(selection, i) in selections"
            :key="i"          
            class="d-inline-flex shrink ma-1"
            :disabled="loading"
            color="grey lighten-3"
            close
            @click:close="selected.splice(i, 1)"
          >
            <v-icon id="dragHandle" style="cursor: move;">
              mdi-reorder-horizontal
            </v-icon>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="black"
                  class="px-2 ml-1"
                  min-width="0"
                  small
                  text 
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-menu-down</v-icon>
                  {{ selection.function.toUpperCase() }} | {{ selection.text.toUpperCase() }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in dropdownitemsComputed(selection.type)"
                  :key="index"
                  @click="selection.function = item.function"
                >
                  <v-list-item-title>
                    {{ item.function }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-chip>
        </draggable>
      </v-row>
      <v-row class="mt-n5">
        <v-col v-if="!allSelected" cols="12" md="4">
          <v-text-field
            ref="search"
            v-model="search"
            hide-details
            prepend-icon="mdi-magnify"
            label="Pesquisar campo"
            single-line
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="!allSelected" cols="12" md="5" class="ml-n3 mt-n5">
          <v-checkbox
            v-model="todosCheckbox"
            @change="todosOsCampos()"
          >        
            <template v-slot:label>
              <span class="black--text">Selecionar todos os campos</span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-container>

    <div 
      class="transitioncard mt-n5"
      :style="{'overflow': 'hidden', 'max-height': chipContainerHeight}"
    >
      <template v-for="item in categories">
        <v-chip
          class="mr-1 mt-1"
          outlined
          :key="item.key"
          :disabled="loading || todosCheckbox"
          @click="pushChip(item)"
        >
          {{item.text.toUpperCase()}}
        </v-chip>
        
      </template>
    </div>
    <div
      justify="center"
      align="center"
      class="mt-n3"
    >
      <v-btn
        v-if="chipContainerHeight != 'none' && items.length > 0"
        class="mt-2 mb-n3 ml-n7"
        icon
        color="gray"
        @click="
          chipContainerHeight = 'none';
          setChipContainerIsExpanded(true);
        "
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <v-btn
        v-else-if="items.length > 0"
        class="mt-2 mb-n3 ml-n7"
        icon
        color="gray"
        @click="
          chipContainerHeight = '37px';
          setChipContainerIsExpanded(false, 301);
        "
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
  </base-material-card>

</template>

<script>
  export default {
    name: 'CamposValores',

    components: {
      draggable: () => import('vuedraggable')
    },

    props: {
      items: {
        type: Array,
        default: ()=> []
      },
      consulta: {
        type: Object,
        default: ()=> {}
      },
    },

    data: () => ({
      dropdownitems: [
        {
          function: 'SOMAR',
          types: ['integer','biginteger','decimal','float','double']
        },
        {
          function: 'MEDIA',
          types: ['integer','biginteger','decimal','float','double']
        },
        {
          function: 'CONTAR',
          types: ['integer','biginteger','string','text','datetime','date']
        },
        {
          function: 'MÍNIMO',
          types: ['integer','biginteger','decimal','float','double','datetime','date'],
        },
        {
          function: 'MÁXIMO',
          types: ['integer','biginteger','decimal','float','double','datetime','date']
        }
      ],
      loading: false,
      search: '',
      selected: [],
      todosCheckbox: false,
      chipContainerIsExpanded: false,
      chipContainerHeight: '37px',
    }),

    computed: {
      allSelected () {
        //return this.selected.length === this.items.length
        return false
      },
      categories () {
        const search = this.search.toLowerCase();
        
        let categoriesList = JSON.parse(JSON.stringify(this.items));

        if (search) {
          return categoriesList.filter(item => {
            const text = item.text.toLowerCase();

            return text.indexOf(search) > -1;
          });
        } 
        
        if (!this.chipContainerIsExpanded) {
          categoriesList = categoriesList.filter(item => item.type != "date");
        }

        return categoriesList
          .sort((a, b) => {
            if (a.type != "date" && b.type == "date") return -1;
          });
      },
      selections () {
        const selections = []

        for (const selection of this.selected) {
          selections.push(selection)
        }

        return selections
      },
      dragOptions() {
        return {
          animation: 250,
          ghostClass: "ghost"
        };
      }
    },

    watch: {
      selected () {
        this.search = ''
      },
      items() {
        this.selected = [];
        this.todosCheckbox = false;

        if(Object.keys(this.selected).length <= 1){
          this.getConsultaCampos()
        }
      },
    },

    methods: {
      getConsultaCampos () {
        if(Object.keys(this.consulta).length !== 0) {
          const campos = JSON.parse(this.consulta.estrutura_json).campos.filter(
            campo => campo.funcao != "AGRUPAR"
          );

          if(
            campos.length === this.categories.length &&
            campos.every((val, i) => val.funcao === "" && val.campo === this.categories[i].text)
          ) {
            this.todosCheckbox = true;
          } else {
            campos.forEach(campo => {
              this.items.forEach(item => {
                if(campo.campo === item.text) {
                  this.pushChip(item, campo.funcao);
                }
              });
            });
          }
        }
      },

      pushChip (item, funcao = false) {

        if(!funcao){

          if (['integer','biginteger','decimal','float','double'].indexOf(item.type) !== -1){
            item.function = 'SOMAR'
          } else if (['date','datetime'].indexOf(item.type) !== -1) {
            item.function = 'MÁXIMO'
          } else {
            item.function = 'CONTAR'
          }
        } else {
          switch(funcao){
            case 'SUM':
              item.function = 'SOMAR'
              break
            case 'MIN':
              item.function = 'MÍNIMO'
              break
            case 'MAX':
              item.function = 'MÁXIMO'
              break
            case 'AVG':
              item.function = 'MÉDIA'
              break
            default:
              item.function = 'CONTAR'
              break
          }
        }
        const clone = {
          text: item.text,
          function: item.function,
          type: item.type,
        } 
        
        this.selected.push(clone)
      },

      dropdownitemsComputed: function (type) {
        let array =  this.dropdownitems.filter( element => {
          return element.types.indexOf(type) !== -1
        });

        return array
      },

      todosOsCampos () {
        this.selected = []
      },

      exportCampos () {
        if(this.todosCheckbox) {
          var categories = JSON.parse(JSON.stringify(this.categories));
          return categories;
        }

        var selected = JSON.parse(JSON.stringify(this.selected));
        return selected
      },

      next () {
        this.loading = true

        setTimeout(() => {
          this.search = ''
          this.selected = []
          this.loading = false
        }, 2000)
      },

      setChipContainerIsExpanded(value, timeout = 0) {
        setTimeout(() => {
          this.chipContainerIsExpanded = value;
        }, timeout);
      }
    },
  }
</script>

<style scoped>
  .transitioncard{
    transition: max-height 0.3s ease-in-out;
  }

  .ghost {
    opacity: 0.5;
  }
</style>>